<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div style="margin-bottom:16px">
            <span class="title">菜单目录</span>
            <el-button type="primary" style="float:right" @click="addDirectory">添加</el-button>
          </div>
          <el-select v-model="value" placeholder="请选择子系统" @change="getContents">
            <el-option
              v-for="item in systemList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <div
          id="custom-tree"
          v-for='(items, index) in data'
          :key="index"
        >
          <div class="group-item">
            <div
              class="active-group"
              @click.stop=handleNodeClick(items,$event,true)
            >
            <i class="el-tree-node__expand-icon el-icon-caret-right" />
              <!-- <img
                class="file"
                src="@/assets/icon.png"
              /> -->
              <i class="el-icon-poc"/>
              <div class="title-group">
                  <div class="lable-text">{{items.name}}</div>
                  <div class="icon-list">
                    <i  class="iconfont"  @click="editDirectory">&#xe68d;</i>
                    <i class="iconfont"   @click="removeMenu(items.appId, items.id, items.name)">&#xe64c;</i>
                  </div>
                </div>
            </div>
            <div
              v-for='(itemss, indexs) in items.child'
              v-if='items.child.length>=1'
              :key="indexs"
              class="option-group"
              @click.stop=handleNodeClick(itemss,$event,false)
            >
              {{itemss.name}}
              <div class="icon-list">
                <i class="iconfont"  @click="editDirectory" >&#xe68d;</i>
                <i class="iconfont"  @click="removeMenu(itemss.appId, itemss.id, itemss.name)">&#xe64c;</i>
              </div>
            </div>
          </div>
        </div>
        </div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content bg-purple pageContent">
          <div style="margin-bottom:16px">
            <span class="title">页面元素</span>
            <el-button type="primary" style="float:right" :disabled="pageOpen" @click="addPage(0)">添加</el-button>
          </div>
          <el-table
            :key="tableKey"
            ref="multipleTable"
            v-loading="listLoading"
            stripe
            :data="eleList"
            tooltip-effect="dark"
            style="width: 100%"
            @cell-mouse-enter="operateShow"
            @cell-mouse-leave="operateClose"
            @row-click="tableClick"
          >
            <el-table-column :show-overflow-tooltip="true" fixed label="元素名称" min-width="100px">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="元素编号" min-width="100px">
              <template slot-scope="scope">{{ scope.row.code }}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100px">
              <template slot-scope="scope">
                <div class="icon">
                  <i
                    class="el-icon-edit"
                    style="margin-right:16px"
                    @click="addPage(1,scope.row.id)"
                  />
                  <i class="el-icon-delete" @click="delet(scope.row.parentId,scope.row.name,scope.row.id,0)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content bg-purple">
          <div style="margin-bottom:16px">
            <span class="title">API</span>
            <el-button type="primary" style="float:right" :disabled="apiOpen" @click="addApi(0)">添加</el-button>
          </div>
          <el-table
            :key="tableKey"
            ref="multipleTable"
            v-loading="listLoading"
            stripe
            :data="list"
            tooltip-effect="dark"
            style="width: 100%"
            @cell-mouse-enter="show"
            @cell-mouse-leave="hide"
          >
            <el-table-column :show-overflow-tooltip="true" fixed label="元素类型" min-width="100px">
              <template slot-scope="scope">
                <span v-if="scope.row.menuType==1">页面</span>
                <span v-if="scope.row.menuType==2">API</span>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="元素key" min-width="100px">
              <template slot-scope="scope">{{ scope.row.code }}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="元素名称" min-width="100px">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100px">
              <template slot-scope="scope">
                <div class="icon">
                  <i
                    class="el-icon-edit"
                    style="margin-right:16px"
                    @click="addApi(1,scope.row.id)"
                  />
                  <i class="el-icon-delete" @click="delet(scope.row.parentId,scope.row.name,scope.row.id,1)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!-- 添加菜单目录 -->
    <div v-if="addMenu">
     
        <AddMenu :key="new Date().getTime()" :click-type="type" :sys-id="sysId" :parent-id="mainId" :is-hide="mainFlag" @returnResult="systemReturn" />
  
    </div>
    <!-- 菜单目录详情 -->
    <div v-if="editMenu">
      
        <MenuDetail :key="new Date().getTime()" :menu-id="menuId" :appid="appId" :parent-id="parentId" :click-type="type" @returnResult="systemReturn" :nav-name="parentName"/>
   
    </div>
    <!-- 添加页面元素 -->
    <div v-if="addElement">
    
        <AddElement
          :key="new Date().getTime()"
          :menu-id="menuId"
          :click-type="type"
          :ele-id="id"
          :app-id="appId"
          @returnResult="receiveData"
        />
  
    </div>
    <!-- 添加api -->
    <div v-if="addPort">
      
        <AddPort
          :key="new Date().getTime()"
          :menu-id="menuId"
          :click-type="type"
          :api-id="id"
          :page-id="parentId"
          :app-id="appId"
          @returnResult="apiReceive"
        />
    </div>
  </div>
</template>
<script>
import AddMenu from '../AddMenu'
import AddElement from '../AddElement'
import AddPort from '../AddPort'
import MenuDetail from '../menuDetail'
import jq from 'jquery'
import { getSystem, permissionsList, search, removePage, deleteMenu, menuType } from '@/api/system'
export default {
  components: {
    AddMenu,
    AddElement,
    AddPort,
    MenuDetail
  },
  data() {
    return {
      addElement: false,
      addMenu: false,
      addPort: false,
      editMenu: false,
      systemList: [],
      value: null,
      listLoading: false,
      tableKey: 0,
      list: [],
      data: [],
      treeProps: {
        value: 'id',
        label: 'name',
        children: 'child'
      },
      menuId: null,
      eleList: [],
      type: null,
      id: null,
      sysId: null,
      appId: null,
      parentId: null,
      isShow: false,
      pageOpen: true,
      apiOpen: true,
      resData: [],
      parentId: '',
      flag: 0,
      mainId: null,
      mainFlag: false,
      menuType: 1,
      sysId: '',
      parentName:""
    }
  },

  mounted() {
    this.getSystemList()
  },
  methods: {
    // 系统
    getSystemList() {
      getSystem({
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        if (res && res.code == 0) {
          this.systemList = res.data.items
        }
      })
    },
    // 权限
    getPermissionsList(data) {
      permissionsList({
        appId: data
      }).then(res => {
        if (res && res.code == 0) {
          this.data = res.data
        }
      })
    },
    // 树
    getContents(data) {
      this.sysId = data
      console.log(this.sysId)
      menuType({
        appId: this.sysId,
        menuType: 5
      }).then(res => {
        if (res && res.code == 0) {
          this.mainFlag = res.data
        }
      })
      this.getPermissionsList(data)
    },
    // 获取页面
    getPage(data) {
      search({
        // menuId: data,
        parentId: this.parentId,
        menuType: this.menuType
      }).then(res => {
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].menuType == 1 && this.flag == 0) {
            this.eleList.push(res.data[i])
          } else if (res.data[i].menuType == 2 && this.flag == 1) {
            this.list.push(res.data[i])
          }
        }
        
      })
    },
    addDirectory() {
      console.log(this.sysId)
      this.addMenu = true
      
    },
    editDirectory(data) {
      this.menuId = data.id
      this.parentId = data.parentId
      this.editMenu = true
      this.type = 1
    },
    addPage(data, id) {
      console.log(id)
      this.type = data
      this.id = id
      this.addElement = true
    },
    addApi(data, id) {
      this.type = data
      this.id = id
      this.addPort = true
    },
    delet(pId,data, id, type) {
      console.log()
      const _this=this
      this.$confirm('删除上级，下级也会被删除，确定删除页面 ' + data + ' 吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        removePage({
          ids: id
        }).then(res => {
          if (res && res.code == 0) {
            this.$message.success('删除成功')
            if (type == 0) {
              this.menuType = 1
              this.parentId = this.sysId
              // console.log(JSON.stringify(this.eleList.length))
              this.list=[]
              if(this.eleList.length>=1){
                for(var i =0;this.eleList.length;i++){
             
                 
                    if(_this.eleList[i]['id']==id){
                  _this.eleList.splice(i,1)
                }
                  
                
              }
              }else{
                this.eleList=[]
              }
              console.log(this.eleList)
            } else if (type == 1) {
              this.apiReceive()
            }
          } 
        })
      }).catch(() => { })
    },
    handleNodeClick(data, that, isParent) {
      if(data.menuType!=4){
        this.parentName=data.name
      }
      this.styleRender(data,that, isParent)
      this.flag = 0
      this.menuId = data.id
      const id = data.id
      this.appId = data.appId
      this.mainId = data.id
      this.eleList = []
      this.list = []
      this.apiOpen = true
      this.parentId = data.id
      this.menuType=1
      if (data.parentId !== 0) {
      
        this.pageOpen = false
        this.menuType = 1
        this.getPage(id)
      } else {
        this.pageOpen = true
      }
      if(data.menuType==5){
        this.pageOpen=false
        this.getPage(id)
      }
    },
    tableClick(row) {
      console.log(row)
      this.flag = 1
      this.appId=row.appId
      this.list = []
      this.apiOpen = false
      this.parentId = row.id
      this.menuType = 2
      this.sysId = row.parentId
      this.getPage(this.menuId)
     
    },
    receiveData() {
      this.addMenu = false
      this.addElement = false
      this.addPort = false
      this.editMenu = false
      this.list = []
      this.eleList = []
      this.getPage()
      // this.getPermissionsList(this.sysId)
    },
    systemReturn(data) {
      this.addMenu = false
      this.addElement = false
      this.addPort = false
      this.editMenu = false
      this.value=data
      if(data){
         this.getPermissionsList(data)
      }
     
    },
    apiReceive() {
      this.addMenu = false
      this.addElement = false
      this.addPort = false
      this.editMenu = false
      this.list = []
      this.getPage()
    },
    // 删除菜单
    removeMenu(appId, id, name) {
      this.$confirm('删除上级，下级也会被删除，确定删除菜单' + name + '吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteMenu({
          appId: appId,
          id: id
        }).then(res => {
          if (res && res.code == 0) {
            this.$message.success('删除成功')
            this.getPermissionsList(this.sysId)
            this.eleList=[]
            this.list=[]
          } 
        })
      }).catch(() => { })
    },
    // 显示操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[2].children[0].children[0].style.display = 'block'
    },
    operateClose() {
      event.path[1].cells[2].children[0].children[0].style.display = 'none'
    },
    show(row, column, cell, event) {
      event.path[1].cells[3].children[0].children[0].style.display = 'block'
    },
    hide() {
      event.path[1].cells[3].children[0].children[0].style.display = 'none'
    },
    styleRender (data,that, isParent) {
      if (isParent) {
        jq("#custom-tree .option-group").animate({ height: '0px' }, 0.5)
        jq("#custom-tree .active-group").removeClass('active')
        jq("#custom-tree .el-tree-node__expand-icon").removeClass('expanded')
        jq(that.currentTarget).addClass('active')
        if(data.menuType!==5){
          jq(that.currentTarget).children('.el-tree-node__expand-icon').addClass('expanded')
          jq(that.currentTarget).siblings('.option-group').animate({ height: '26px' }, 0.5)
        }
   
        
      } else {
        jq("#custom-tree .option-group").removeClass('active-option')
        jq(that.currentTarget).addClass('active-option')
      }
      that.stopPropagation()
    },
  }
}
</script>
<style lang="scss" scoped>
.pageContent {
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  min-height: calc(100vh - 218px);
  padding: 0 24px;
}
.title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}
body .app-wrapper-new-style .app-container {
  padding-left: 24px;
  padding-top: 32px;
}
.el-select {
  width: 100%;
}
.el-tree {
  margin-top: 24px;
  font-size: 12px;
}
.icon {
  display: none;
}
.file {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: contain;
  background-image: url("../../../../assets/icon.png");
  margin-right: 8px;
  position: relative;
  top: 3px;
}
.menuIcon {
  position: absolute;
  right: 0;
  display: none;
}
.el-tree-node__content:hover .menuIcon {
  display: inline-block;
}
.group-list {
  display: inline-block;
  padding-right: 10px;
  width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
#custom-tree {
  /* width: 300px; */
  font-size: 12px;
  color: #606266;
  line-height: 26px;
  background: #ffffff;
  cursor: pointer;
  position: relative;
  .file {
    width: 16px;
    height: 16px;
    display: inline-block;
    background-size: contain;
    margin-right: 8px;
    position: relative;
    top: 3px;
  }
  .icon-list {
    margin-left: 10px;
    display: none;
    position: absolute;
    right:8px;
    i {
      margin-left: 10px;
    }
  }
  .title-group {
    display: inline-block;
  }
  .title-group .lable-text,
  .option-group .lable-text {
    width: 150px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    margin-bottom: -9px;
  }
  .el-tree-node__expand-icon {
    cursor: pointer;
    font-size: 12px;
    transform: rotate(0deg);
    transition: transform 0.5s ease-in-out;
  }
  .expanded {
    transform: rotate(90deg);
  }
  .option-group {
    height: 0px;
    padding-left: 40px;
    overflow: hidden;
  }
  .active-group:hover,
  .option-group:hover {
    background: rgba($color: #ffa940, $alpha: 0.1);
    .icon-list {
      display: inline-block;
    }
  }
  .active {
    background: rgba($color: #ffa940, $alpha: 0.85);
    color: #ffffff;
    .el-tree-node__expand-icon {
      color: #ffffff;
    }
    .icon-list {
      display: inline-block;
    }
    .iconfont{
      color:rgba(255,255,255,0.85)
    }
    .el-icon-poc{
      background-image: url("../../../../assets/pocket.png");
    }
  }
  .active:hover {
    background: rgba($color: #ffa940, $alpha: 0.85);
  }
  .active-option {
    color: rgba($color: #ffa940, $alpha: 0.85);
    .icon-list {
      display: inline-block;
    }
  }
}
</style>
